/* eslint-disable no-unused-vars */
import React from 'react';


const NotAuthorised = () => {
  
  
   


   
  return (
    <div className='row'>
        <div className='col-md-12'>
            <h3> You are not authorised to use this feature.Contact Your Admin for support</h3>
        </div>
     




        
    </div>
  );
};
NotAuthorised.displayName = "NotAuthorised"
export default NotAuthorised;
